import * as ACTION from 'constant/action/carousel'
import { handleActions } from 'redux-actions'

const initialState = {
  carouselInformation: []
}

export default handleActions(
  {
    [ACTION.UPDATE_CAROUSEL]: (state, action) => ({
      ...state,
      carouselInformation: action.payload
    })
  },
  initialState
)
